import { CHANNELS, HELPER_ARTICLES, ENABLED_CHANNELS } from '../../constants';

import facebookLogo from './images/facebook.svg';
import facebookAdsLogo from './images/facebook-ads.svg';
import instagramLogo from './images/instagram.svg';
import twitterLogo from './images/twitter.svg';
import youtubeLogo from './images/youtube.svg';
import linkedinLogo from './images/linkedin.svg';
import tiktokLogo from './images/tiktok.svg';
import pinterestLogo from './images/pinterest.svg';
import googleMyBusinessLogo from './images/google-my-business.svg';
import spotifyAdsLogo from './images/spotify-ads.svg';
import bingAdsLogo from './images/bing-ads.svg';
import googleAdsLogo from './images/google-ads.svg';
import quoraAdsLogo from './images/quora-ads.svg';
import redditAdsLogo from './images/reddit-ads.svg';
import mailchimpLogo from './images/mailchimp.svg';
import hubspotLogo from './images/hubspot.svg';
import mailshakeLogo from './images/mailshake.svg';
import pipedriveLogo from './images/pipedrive.svg';
import salesforceLogo from './images/salesforce.svg';
import activeCampaignLogo from './images/active-campaign.svg';
import constantContactLogo from './images/constant-contact.svg';
import semRushLogo from './images/sem-rush.svg';
import googleAnalyticsLogo from './images/google-analytics.svg';
import seoMonitorLogo from './images/seo-monitor.svg';
import shopifyLogo from './images/shopify.svg';
import bigCommerceLogo from './images/big-commerce.svg';
import wooCommerceLogo from './images/woo-commerce.svg';
import brevoLogo from './images/brevo.webp';
import lemlistLogo from './images/lemlist.svg';
import gmassLogo from './images/gmass.png';
import dripLogo from './images/drip.svg';
import convertKitLogo from './images/convertkit.svg';
import googleSearchConsoleLogo from './images/google-search-console.svg';
import plausibleLogo from './images/plausible.svg';
import klaviyoLogo from './images/klaviyo.svg';
import closeLogo from './images/close.svg';
import zohoLogo from './images/zoho.svg';
import adobeAnalyticsLogo from './images/adobe-analytics.svg';
import googleSheetLogo from './images/google-sheets.svg';
import flodeskLogo from './images/flodesk.png';
import echargeLogo from './images/echarge.svg';
import jsonApiLogo from './images/jsonApi.svg';

const socialsList = [
  {
    logo: facebookLogo,
    provider: CHANNELS.facebook,
    isDisabled: !ENABLED_CHANNELS.includes('facebook'),
    displayName: 'Facebook',
  },
  {
    logo: instagramLogo,
    provider: CHANNELS.instagram,
    isDisabled: !ENABLED_CHANNELS.includes('instagram'),
    hintElement: (
      <div className="AddClientModal__hint">
        Connect through
        <br />
        Facebook.{' '}
        <a
          href={HELPER_ARTICLES.CONNECTING_INSTAGRAM_ACCOUNT}
          target="_blank"
          rel="noreferrer"
        >
          Learn more
        </a>
      </div>
    ),
    displayName: 'Instagram',
  },
  {
    logo: twitterLogo,
    provider: CHANNELS.twitter,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.twitter),
    displayName: 'Twitter',
  },
  {
    logo: linkedinLogo,
    provider: CHANNELS.linkedin,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.linkedin),
    displayName: 'LinkedIn',
  },
  {
    logo: youtubeLogo,
    provider: CHANNELS.youtube,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.youtube),
    displayName: 'YouTube',
  },
  {
    logo: tiktokLogo,
    provider: CHANNELS.tiktok,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.tiktok),
    displayName: 'TikTok',
  },
  {
    logo: pinterestLogo,
    provider: CHANNELS.pinterest,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.pinterest),
    displayName: 'Pinterest',
  },
  {
    logo: googleMyBusinessLogo,
    provider: CHANNELS.googleMyBusiness,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.googleMyBusiness),
    displayName: 'Google My Business',
  },
  {
    logo: facebookAdsLogo,
    provider: CHANNELS.facebookAds,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.facebookAds),
    displayName: 'Facebook Ads',
  },
  {
    logo: linkedinLogo,
    provider: CHANNELS.linkedinAds,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.linkedinAds),
    displayName: 'LinkedIn Ads',
  },
  {
    logo: spotifyAdsLogo,
    provider: CHANNELS.spotifyAds,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.spotifyAds),
    displayName: 'Spotify Ads',
  },
  {
    logo: bingAdsLogo,
    provider: CHANNELS.bingAds,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.bingAds),
    displayName: 'Bing Ads',
  },
  {
    logo: googleAdsLogo,
    provider: CHANNELS.googleAds,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.googleAds),
    displayName: 'Google Ads',
  },
  {
    logo: youtubeLogo,
    provider: CHANNELS.youtubeAds,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.youtubeAds),
    displayName: 'YouTube Ads',
  },
  {
    logo: quoraAdsLogo,
    provider: CHANNELS.quoraAds,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.quoraAds),
    displayName: 'Quora Ads',
  },
  {
    logo: redditAdsLogo,
    provider: CHANNELS.redditAds,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.redditAds),
    displayName: 'Reddit Ads',
  },
  {
    logo: twitterLogo,
    provider: CHANNELS.twitterAds,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.twitterAds),
    displayName: 'Twitter Ads',
  },
  {
    logo: mailchimpLogo,
    provider: CHANNELS.mailchimp,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.mailchimp),
    displayName: 'Mailchimp',
  },
  {
    logo: hubspotLogo,
    provider: CHANNELS.hubspot,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.hubspot),
    displayName: 'HubSpot',
  },
  {
    logo: mailshakeLogo,
    provider: CHANNELS.mailshake,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.mailshake),
    displayName: 'Mailshake',
  },
  {
    logo: pipedriveLogo,
    provider: CHANNELS.pipedrive,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.pipedrive),
    displayName: 'Pipedrive',
  },
  {
    logo: salesforceLogo,
    provider: CHANNELS.salesforce,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.salesforce),
    displayName: 'Salesforce',
  },
  {
    logo: activeCampaignLogo,
    provider: CHANNELS.activeCampaign,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.activeCampaign),
    displayName: 'Active Campaign',
  },
  {
    logo: constantContactLogo,
    provider: CHANNELS.constantContact,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.constantContact),
    displayName: 'Constant Contact',
  },
  {
    logo: semRushLogo,
    provider: CHANNELS.semRush,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.semRush),
    displayName: 'SEMrush',
  },
  {
    logo: googleAnalyticsLogo,
    provider: CHANNELS.googleAnalytics,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.googleAnalytics),
    displayName: 'Google Analytics',
  },
  {
    logo: googleAnalyticsLogo,
    provider: CHANNELS.googleAnalytics4,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.googleAnalytics4),
    displayName: 'Google Analytics 4',
    exclude: true,
  },
  {
    logo: seoMonitorLogo,
    provider: CHANNELS.seoMonitor,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.seoMonitor),
    displayName: 'SEOmonitor',
  },
  {
    logo: shopifyLogo,
    provider: CHANNELS.shopify,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.shopify),
    displayName: 'Shopify',
  },
  {
    logo: bigCommerceLogo,
    provider: CHANNELS.bigCommerce,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.bigCommerce),
    displayName: 'BigCommerce',
  },
  {
    logo: wooCommerceLogo,
    provider: CHANNELS.wooCommerce,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.wooCommerce),
    displayName: 'WooCommerce',
  },
  {
    logo: tiktokLogo,
    provider: CHANNELS.tiktokAds,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.tiktokAds),
    displayName: 'Tiktok Ads',
  },
  {
    logo: echargeLogo,
    provider: CHANNELS.echarge,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.echarge),
    displayName: 'Echarge',
  },
  {
    logo: brevoLogo, // company rebranded to brevo
    provider: CHANNELS.brevo,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.brevo),
    displayName: 'Brevo',
  },
  {
    logo: lemlistLogo,
    provider: CHANNELS.lemList,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.lemList),
    displayName: 'Lemlist',
  },
  {
    logo: gmassLogo,
    provider: CHANNELS.gmass,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.gmass),
    displayName: 'Gmass',
  },
  {
    logo: dripLogo,
    provider: CHANNELS.drip,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.drip),
    displayName: 'Drip',
  },
  {
    logo: convertKitLogo,
    provider: CHANNELS.convertKit,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.convertKit),
    displayName: 'ConvertKit',
  },
  {
    logo: googleSearchConsoleLogo,
    provider: CHANNELS.googleSearchConsole,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.googleSearchConsole),
    displayName: 'Google Search Console',
  },
  {
    logo: plausibleLogo,
    provider: CHANNELS.plausible,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.plausible),
    displayName: 'Plausible',
  },
  {
    logo: klaviyoLogo,
    provider: CHANNELS.klaviyo,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.klaviyo),
    displayName: 'Klaviyo',
  },
  {
    logo: closeLogo,
    provider: CHANNELS.close,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.close),
    displayName: 'Close',
  },
  {
    logo: zohoLogo,
    provider: CHANNELS.zoho,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.zoho),
    displayName: 'Zoho',
  },
  {
    logo: adobeAnalyticsLogo,
    provider: CHANNELS.adobeAnalytics,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.adobeAnalytics),
    displayName: 'Adobe Analytics',
  },
  {
    logo: jsonApiLogo,
    provider: CHANNELS.jsonApi,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.jsonApi),
    displayName: 'JSON API',
  },
  {
    logo: googleSheetLogo,
    provider: CHANNELS.googleSheet,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.googleSheet),
    displayName: 'Google Sheet',
  },
  {
    logo: flodeskLogo,
    provider: CHANNELS.flodesk,
    isDisabled: !ENABLED_CHANNELS.includes(CHANNELS.flodesk),
    displayName: 'Flodesk',
  },
];

export const mapProviderToUpvote = {
  [CHANNELS.tiktok]: 'social-tiktok',
  [CHANNELS.pinterest]: 'social-pinterest',
  [CHANNELS.googleMyBusiness]: 'social-google-my-business',
  [CHANNELS.facebookAds]: 'ads-facebook',
  [CHANNELS.linkedinAds]: 'ads-linkedin',
  [CHANNELS.spotifyAds]: 'ads-spotify',
  [CHANNELS.bingAds]: 'ads-bing',
  [CHANNELS.googleAds]: 'ads-google',
  [CHANNELS.youtubeAds]: 'ads-youtube',
  [CHANNELS.quoraAds]: 'ads-quora',
  [CHANNELS.redditAds]: 'ads-reddit',
  [CHANNELS.twitterAds]: 'ads-twitter',
  [CHANNELS.mailchimp]: 'emails-mailchimp',
  [CHANNELS.hubspot]: 'emails-hubspot',
  [CHANNELS.mailshake]: 'emails-mailshake',
  [CHANNELS.pipedrive]: 'emails-pipedrive',
  [CHANNELS.salesforce]: 'emails-salesforce',
  [CHANNELS.activeCampaign]: 'emails-active-campaign',
  [CHANNELS.constantContact]: 'emails-constant-contact',
  [CHANNELS.semRush]: 'website-sem-rush',
  [CHANNELS.googleAnalytics]: 'website-google-analytics',
  [CHANNELS.seoMonitor]: 'website-seo-monitor',
  [CHANNELS.shopify]: 'ecom-shopify',
  [CHANNELS.bigCommerce]: 'ecom-big-commerce',
  [CHANNELS.wooCommerce]: 'ecom-woo-commerce',
  [CHANNELS.tiktokAds]: 'ads-tik-tok',
  [CHANNELS.echarge]: 'emails-echarge',
  [CHANNELS.brevo]: 'emails-brevo',
  [CHANNELS.lemList]: 'emails-lem-list',
  [CHANNELS.gmass]: 'emails-gmass',
  [CHANNELS.drip]: 'emails-drip',
  [CHANNELS.convertKit]: 'emails-convert-kit',
  [CHANNELS.googleSearchConsole]: 'website-google-search-console',
  [CHANNELS.plausible]: 'website-plausible',
  [CHANNELS.klaviyo]: 'ecom-klaviyo',
  [CHANNELS.close]: 'other-close',
  [CHANNELS.zoho]: 'other-zoho',
  [CHANNELS.adobeAnalytics]: 'other-adobe-analytics',
  [CHANNELS.jsonApi]: 'json-api',
  [CHANNELS.googleSheet]: 'google-sheet',
  [CHANNELS.flodesk]: 'flodesk',
};

export default socialsList;
